import { APP_PERMISSIONS } from '@exam-center/permission';
import { ProctoringUserDetailsPageHeader } from '@exam-center/proctoring-details';
import { ProctoringEKycVerificationProvider } from '@exam-center/proctoring-ekyc-verification';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ProctoringEKycVerificationLayout() {
  const { examCenterCode, examEventId, examineeId } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc/:examineeId',
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.PROCTORING.E_KYC.VIEW}>
      <ProctoringEKycVerificationProvider
        examCenterCode={examCenterCode}
        examEventId={examEventId}
        examineeId={examineeId}
      >
        <ProctoringUserDetailsPageHeader />
        <Outlet />
      </ProctoringEKycVerificationProvider>
    </PermissionGuard>
  );
}
